export default "__VITE_ASSET__a3186b90__"